import { useCurrentRefinements, useInfiniteHits } from 'react-instantsearch';
import { type RepubIs } from '@cx-web/utils';

import { type BookmakersConfig } from '@cx-modules/types';

import { type BetInsightsConfig } from '~/configuration/BetInsightsConfiguration';
import { type BettingInsightsContent, type BettingInsightsResult, type EsIndex } from '~/configuration/types';

import { LockableCategoriesRefinement } from './Filters/CategoriesRefinement';
import { Sidebar } from './Sidebar';

export function BettingInsightsRefinements<
  TIndex extends EsIndex,
  TContent extends BettingInsightsContent<TIndex>,
  TResult extends BettingInsightsResult<TIndex>,
>({
  bookmakers,
  config,
  currentPath,
  indexName,
  isLoggedIn,
  repubIs,
  repubPath,
  resourcesUrl,
  variant = 'default',
}: {
  bookmakers: BookmakersConfig;
  config: BetInsightsConfig<TIndex, TContent>;
  currentPath: string;
  indexName: TIndex;
  isLoggedIn: boolean;
  repubIs: RepubIs;
  repubPath: string;
  resourcesUrl: string;
  variant?: 'default' | 'compact';
}) {
  const { items: refinements } = useCurrentRefinements();
  let { items, results } = useInfiniteHits<TResult>();

  const canSort = config.ui.sorting?.canSort?.({ refinements }) ?? true;
  const hasResults = Boolean(items.length);
  const categories = config.ui.results.categories();

  return (
    <>
      <Sidebar
        bookmakers={bookmakers}
        canSort={canSort}
        config={config}
        currentPath={currentPath}
        indexName={indexName}
        isLoggedIn={isLoggedIn}
        items={items}
        repubIs={repubIs}
        repubPath={repubPath}
        resourcesUrl={resourcesUrl}
        results={results || undefined}
        variant={variant}
      />
      {categories && (
        <LockableCategoriesRefinement
          categories={categories}
          hasResults={hasResults}
          isWalled={config.isWalled}
          repubIs={repubIs}
        />
      )}
    </>
  );
}
